import React from 'react';
import s from './HeaderBlock.module.scss';

import {ReactComponent as ReactLogoSvg} from "../../logo.svg";

const HeaderBlock = ({hideBackground=false, img, background, children}) => {
    const styleCover = hideBackground ? {backgroundImage: 'none'} : {};
    const styleBackground = background ? {backgroundColor: `${background}`} : {backgroundColor: 'none'};
    const styleImg = img ? {backgroundImage: `${img}`} : {};
    return (
        <div className={s.cover} style={styleImg}>
            <div className={s.wrap}>
                <ReactLogoSvg/>
                {children}
            </div>
        </div>
    );
}

export default HeaderBlock;